import { jsx as e, jsxs as C } from "react/jsx-runtime";
import { useLocation as E, Link as b, Routes as w, Route as y, Navigate as $ } from "react-router-dom";
import { UsersPage as B, CapabilitiesProvider as N, VoiceProOnboardingWizard as L, EditInvitationPage as z, InvitationDetailPage as M, CreateInvitationPage as U, InvitationsPage as j, LoginAttemptDetailPage as H, LoginAttemptHistoryPage as K, SessionDetailPage as V, SessionsPage as W, EditConsentPage as _, ConsentDetailPage as q, CreateConsentPage as J, ConsentsPage as G, EditFeatureFlagPage as Q, FeatureFlagDetailPage as X, CreateFeatureFlagPage as Y, FeatureFlagsPage as Z, EditFeaturePage as ee, FeatureDetailPage as te, CreateFeaturePage as ne, FeaturesPage as se, EditUserPage as ae, UserDetailPage as ie, CreateUserPage as oe, EditRolePage as re, RoleDetailPage as le, CreateRolePage as ce, RolesPage as de, EditPermissionPage as me, PermissionDetailPage as pe, CreatePermissionPage as ue, PermissionsPage as ge, PermissionAssignmentDetailPage as fe, EditPermissionAssignmentPage as he, CreatePermissionAssignmentPage as Ie, PermissionAssignmentsPage as Pe, SettingsPage as ve, UserProfilesPage as Ce, EditTenantPage as be, CreateTenantPage as ye, TenantsPage as ke, DashboardPage as Fe } from "@digiwedge/access-control-pages";
import { AccessControlApiProvider as Ae } from "@digiwedge/access-control-api-hooks";
import * as Ee from "react";
import { useMemo as v, useState as S, useEffect as x, useCallback as Se } from "react";
import { BreadcrumbComponent as xe, HeaderComponent as Re, SidebarComponent as Oe, FooterComponent as De } from "@digiwedge/ui-antd";
import { appRoutes as Te, sidebarItems as k } from "@digiwedge/access-control-common";
import { theme as R, Badge as we, Input as $e, App as Be, message as Ne, Skeleton as Le } from "antd";
import { SearchOutlined as ze } from "@ant-design/icons";
function O(n) {
  const s = "/access-control", a = n.indexOf(s);
  return a === -1 ? n : n.slice(a + s.length) || "/";
}
function Me(n) {
  const a = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/:[^/]+/g, "[^/]+");
  return new RegExp(`^${a}($|/)`);
}
function Ue(n) {
  const a = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/:[^/]+/g, "[^/]+");
  return new RegExp(`^${a}$`);
}
function je(n, s) {
  return Ue(n).test(s);
}
function He(n, s) {
  const a = Te, r = O(n).split("/").filter(Boolean), i = [{ path: "/", name: "Home" }];
  let l = "";
  return r.forEach((d) => {
    l += `/${d}`;
    const g = D(a, l);
    g ? i.push({
      path: l,
      name: g.breadcrumb || F(d)
    }) : i.push({
      path: l,
      name: F(d)
    });
  }), i;
}
function D(n, s) {
  for (const a of n) {
    if (a.children) {
      const o = D(a.children, s);
      if (o) return o;
    }
    if (je(a.path, s)) return a;
  }
  return null;
}
function F(n) {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(n) ? "Details" : n.split("-").map((s) => s.charAt(0).toUpperCase() + s.slice(1)).join(" ");
}
const nt = ({ separator: n, style: s }) => {
  const a = E(), o = v(
    () => He(a.pathname),
    [a.pathname]
  );
  return /* @__PURE__ */ e(xe, { breadcrumbItems: o, separator: n, style: s });
}, Ke = (n = {}) => {
  const { baseUrl: s = "", disabled: a = !1 } = n, [o, r] = S(0);
  return x(() => {
    if (a) {
      r(0);
      return;
    }
    const i = typeof process < "u" && process.env?.CI_OFFLINE === "true", l = async () => {
      if (i) {
        r(0);
        return;
      }
      try {
        const g = s ? `${s}/api/notifications/count` : "/api/notifications/count", u = await fetch(g);
        if (u.ok) {
          const f = await u.json();
          r(f.count);
        } else
          r(0);
      } catch {
        r(0);
      }
    };
    l();
    const d = setInterval(l, 3e4);
    return () => clearInterval(d);
  }, [s, a]), { count: o };
}, Ve = (n) => /* @__PURE__ */ e("span", { role: "img", "aria-label": "bell", ...n, children: "🔔" }), T = ({
  count: n,
  baseUrl: s,
  disabled: a
}) => {
  const { token: o } = R.useToken(), r = a ?? n !== void 0, { count: i } = Ke({ baseUrl: s, disabled: r });
  return /* @__PURE__ */ e(we, { count: n ?? i, children: /* @__PURE__ */ e(Ve, { style: { fontSize: 18, color: o.colorText } }) });
}, We = ({
  onSearch: n,
  placeholder: s = "Search",
  maxWidth: a = 300
}) => {
  const o = Se(
    (r, i) => {
      n(r.trim(), i);
    },
    [n]
  );
  return /* @__PURE__ */ e(
    $e.Search,
    {
      allowClear: !0,
      prefix: /* @__PURE__ */ e(ze, {}),
      placeholder: s,
      onSearch: o,
      style: { maxWidth: a },
      "aria-label": s
    }
  );
}, st = ({
  navItems: n,
  userMenuItems: s,
  notificationsCount: a = 0,
  onSearch: o,
  toggleTheme: r,
  themeMode: i,
  user: l
}) => /* @__PURE__ */ e(
  Re,
  {
    navItems: [
      ...n,
      { key: "search", label: /* @__PURE__ */ e(We, { onSearch: o }) },
      {
        key: "notification",
        label: /* @__PURE__ */ e(T, { count: a, themeMode: i ?? "light" })
      }
    ],
    userMenuItems: s,
    notificationsCount: a,
    user: l ?? void 0
  }
), at = ({
  wsUrl: n = "/ws/events",
  themeMode: s
}) => {
  const [a, o] = S(0), i = Be.useApp?.()?.message ?? Ne;
  return x(() => {
    const l = typeof process < "u" && process.env || void 0, d = globalThis.importMetaEnv;
    if ((l?.CI_OFFLINE ?? "").toString() === "true" || (d?.VITE_CI_OFFLINE ?? "").toString() === "true" || typeof WebSocket > "u") return;
    const u = new WebSocket(n);
    return u.onmessage = (f) => {
      try {
        const h = JSON.parse(f.data);
        h.message && (i.info(h.message), o((c) => c + 1));
      } catch {
      }
    }, () => u.close();
  }, [n, i]), /* @__PURE__ */ e(T, { count: a, themeMode: s });
}, it = Ee.memo(
  ({
    collapsed: n,
    onCollapse: s,
    themeMode: a = "light",
    breakpoint: o = "md",
    style: r,
    className: i,
    sidebarItems: l
  }) => {
    const d = E(), { token: g } = R.useToken(), u = {
      background: g.colorBgContainer,
      ...r
    }, f = v(() => l || k.map((c) => c.children && c.children.length > 0 ? {
      type: "group",
      key: c.key,
      icon: c.icon,
      label: c.label,
      children: c.children.map((t) => ({
        type: "item",
        key: t.key,
        icon: t.icon,
        label: /* @__PURE__ */ e(b, { to: t.key, children: t.label })
      }))
    } : {
      type: "item",
      key: c.key,
      icon: c.icon,
      label: /* @__PURE__ */ e(b, { to: c.key, children: c.label })
    }), [l]), h = v(() => {
      const c = O(d.pathname), I = [...k.flatMap(
        (m) => m.children ? [m.key, ...m.children.map((p) => p.key)] : [m.key]
      )].sort((m, p) => p.length - m.length).find((m) => m.includes(":") ? !1 : Me(m).test(c));
      return I ? [I] : [];
    }, [d.pathname]);
    return /* @__PURE__ */ e(
      Oe,
      {
        collapsed: n,
        onCollapse: s,
        themeMode: a,
        sidebarItems: f,
        selectedKeys: h,
        breakpoint: o,
        style: u,
        className: i
      }
    );
  }
), ot = ({
  text: n = "© 2024 DigiWedge Access Control. All rights reserved.",
  themeMode: s = "light",
  sticky: a = !1,
  links: o,
  socialMedia: r,
  style: i
}) => /* @__PURE__ */ e(De, { text: n, style: i, socialMedia: r }), rt = ({ rows: n = 3 }) => /* @__PURE__ */ e(Le, { active: !0, paragraph: { rows: n } }), A = /* @__PURE__ */ new Set([
  "",
  "users",
  "users/:userId",
  "invitations",
  "sessions",
  "login-attempts"
]), _e = [
  "users/create",
  "users/:userId/edit",
  "invitations/create",
  "invitations/:invitationId",
  "invitations/:invitationId/edit",
  "sessions/:sessionId",
  "login-attempts/:attemptId"
], lt = ({
  authMode: n,
  baseUrl: s,
  credentials: a,
  getAccessToken: o,
  redirectTo: r,
  routeProfile: i = "platform-admin",
  tenantId: l,
  tenantName: d,
  usersPageOptions: g
}) => {
  const u = i === "tenant-admin" ? "users" : "dashboard", f = (r ?? u).replace(/^\//, "") || u, h = i === "tenant-admin" && !A.has(f) ? u : f, c = () => /* @__PURE__ */ C("div", { style: { textAlign: "center", padding: 24 }, children: [
    /* @__PURE__ */ e("h1", { children: "404 - Page Not Found" }),
    /* @__PURE__ */ e("p", { children: "The page you are looking for does not exist." })
  ] }), t = {
    // Dashboard
    dashboard: /* @__PURE__ */ e(Fe, {}),
    // Tenants
    tenants: /* @__PURE__ */ e(ke, {}),
    "tenants/create": /* @__PURE__ */ e(ye, {}),
    "tenants/:tenantId/edit": /* @__PURE__ */ e(be, {}),
    // User Profiles
    "user-profiles": /* @__PURE__ */ e(Ce, {}),
    // Settings
    settings: /* @__PURE__ */ e(ve, {}),
    // Permission Assignments
    "permission-assignments": /* @__PURE__ */ e(Pe, {}),
    "permission-assignments/create": /* @__PURE__ */ e(Ie, {}),
    "permission-assignments/:assignmentId/edit": /* @__PURE__ */ e(he, {}),
    "permission-assignments/:assignmentId": /* @__PURE__ */ e(fe, {}),
    // Permissions
    permissions: /* @__PURE__ */ e(ge, {}),
    "permissions/create": /* @__PURE__ */ e(ue, {}),
    "permissions/:permissionId": /* @__PURE__ */ e(pe, {}),
    "permissions/:permissionId/edit": /* @__PURE__ */ e(me, {}),
    // Roles
    roles: /* @__PURE__ */ e(de, {}),
    "roles/create": /* @__PURE__ */ e(ce, {}),
    "roles/:roleId": /* @__PURE__ */ e(le, {}),
    "roles/:roleId/edit": /* @__PURE__ */ e(re, {}),
    // Users
    users: /* @__PURE__ */ e(
      B,
      {
        readOnly: i === "tenant-admin",
        tenantName: d,
        showVoiceProOnlyFilter: g?.showVoiceProOnlyFilter
      }
    ),
    "users/create": /* @__PURE__ */ e(oe, {}),
    "users/:userId": /* @__PURE__ */ e(ie, { readOnly: i === "tenant-admin" }),
    "users/:userId/edit": /* @__PURE__ */ e(ae, {}),
    // Features
    features: /* @__PURE__ */ e(se, {}),
    "features/create": /* @__PURE__ */ e(ne, {}),
    "features/:featureId": /* @__PURE__ */ e(te, {}),
    "features/:featureId/edit": /* @__PURE__ */ e(ee, {}),
    // Feature Flags
    "feature-flags": /* @__PURE__ */ e(Z, {}),
    "feature-flags/create": /* @__PURE__ */ e(Y, {}),
    "feature-flags/:flagId": /* @__PURE__ */ e(X, {}),
    "feature-flags/:flagId/edit": /* @__PURE__ */ e(Q, {}),
    // Consents
    consents: /* @__PURE__ */ e(G, {}),
    "consents/create": /* @__PURE__ */ e(J, {}),
    "consents/:consentId": /* @__PURE__ */ e(q, {}),
    "consents/:consentId/edit": /* @__PURE__ */ e(_, {}),
    // Sessions
    sessions: /* @__PURE__ */ e(W, {}),
    "sessions/:sessionId": /* @__PURE__ */ e(V, {}),
    // Login Attempts
    "login-attempts": /* @__PURE__ */ e(K, {}),
    "login-attempts/:attemptId": /* @__PURE__ */ e(H, {}),
    // Invitations
    invitations: /* @__PURE__ */ e(j, { readOnly: i === "tenant-admin" }),
    "invitations/create": /* @__PURE__ */ e(U, {}),
    "invitations/:invitationId": /* @__PURE__ */ e(M, {}),
    "invitations/:invitationId/edit": /* @__PURE__ */ e(z, {}),
    // Onboarding
    "onboarding/voicepro": /* @__PURE__ */ e(L, {})
  }, P = [
    // Default redirect
    { path: "", element: /* @__PURE__ */ e($, { to: h, replace: !0 }) },
    // Dashboard
    { path: "dashboard", element: t.dashboard },
    // Tenants
    { path: "tenants", element: t.tenants },
    { path: "tenants/create", element: t["tenants/create"] },
    { path: "tenants/:tenantId/edit", element: t["tenants/:tenantId/edit"] },
    // User Profiles
    { path: "user-profiles", element: t["user-profiles"] },
    // Settings
    { path: "settings", element: t.settings },
    // Permission Assignments
    { path: "permission-assignments", element: t["permission-assignments"] },
    { path: "permission-assignments/create", element: t["permission-assignments/create"] },
    {
      path: "permission-assignments/:assignmentId/edit",
      element: t["permission-assignments/:assignmentId/edit"]
    },
    {
      path: "permission-assignments/:assignmentId",
      element: t["permission-assignments/:assignmentId"]
    },
    // Permissions
    { path: "permissions", element: t.permissions },
    { path: "permissions/create", element: t["permissions/create"] },
    { path: "permissions/:permissionId", element: t["permissions/:permissionId"] },
    { path: "permissions/:permissionId/edit", element: t["permissions/:permissionId/edit"] },
    // Roles
    { path: "roles", element: t.roles },
    { path: "roles/create", element: t["roles/create"] },
    { path: "roles/:roleId", element: t["roles/:roleId"] },
    { path: "roles/:roleId/edit", element: t["roles/:roleId/edit"] },
    // Users
    { path: "users", element: t.users },
    { path: "users/create", element: t["users/create"] },
    { path: "users/:userId", element: t["users/:userId"] },
    { path: "users/:userId/edit", element: t["users/:userId/edit"] },
    // Features
    { path: "features", element: t.features },
    { path: "features/create", element: t["features/create"] },
    { path: "features/:featureId", element: t["features/:featureId"] },
    { path: "features/:featureId/edit", element: t["features/:featureId/edit"] },
    // Feature Flags
    { path: "feature-flags", element: t["feature-flags"] },
    { path: "feature-flags/create", element: t["feature-flags/create"] },
    { path: "feature-flags/:flagId", element: t["feature-flags/:flagId"] },
    { path: "feature-flags/:flagId/edit", element: t["feature-flags/:flagId/edit"] },
    // Consents
    { path: "consents", element: t.consents },
    { path: "consents/create", element: t["consents/create"] },
    { path: "consents/:consentId", element: t["consents/:consentId"] },
    { path: "consents/:consentId/edit", element: t["consents/:consentId/edit"] },
    // Sessions
    { path: "sessions", element: t.sessions },
    { path: "sessions/:sessionId", element: t["sessions/:sessionId"] },
    // Login Attempts
    { path: "login-attempts", element: t["login-attempts"] },
    { path: "login-attempts/:attemptId", element: t["login-attempts/:attemptId"] },
    // Invitations
    { path: "invitations", element: t.invitations },
    { path: "invitations/create", element: t["invitations/create"] },
    { path: "invitations/:invitationId", element: t["invitations/:invitationId"] },
    { path: "invitations/:invitationId/edit", element: t["invitations/:invitationId/edit"] },
    // Onboarding
    { path: "onboarding/voicepro", element: t["onboarding/voicepro"] }
  ], I = i === "tenant-admin" ? [
    ..._e.map((p) => ({ path: p, element: /* @__PURE__ */ e(c, {}) })),
    ...P.filter((p) => A.has(p.path))
  ] : P, m = n === "cookie" ? { authMode: n, credentials: a } : { authMode: n, getAccessToken: o };
  return /* @__PURE__ */ e(Ae, { ...m, baseUrl: s, tenantId: l, children: /* @__PURE__ */ e(N, { ...m, baseUrl: s, tenantId: l, children: /* @__PURE__ */ C(w, { children: [
    I.map((p) => /* @__PURE__ */ e(y, { path: p.path, element: p.element }, p.path)),
    /* @__PURE__ */ e(y, { path: "*", element: /* @__PURE__ */ e(c, {}) })
  ] }) }) });
};
export {
  nt as AccessControlBreadcrumbComponent,
  ot as AccessControlFooterComponent,
  st as AccessControlHeaderComponent,
  lt as AccessControlModule,
  it as AccessControlSidebar,
  T as NotificationBell,
  at as NotificationCenter,
  rt as PageLoader,
  We as SearchInput,
  Ke as useNotificationCount
};
//# sourceMappingURL=index.js.map
